export default __webpack_public_path__ + "assets/c759c05eb1ceb0b280677667335018ad.jpg";